import api from "../..";
import type { ApiResponse } from "../../types";
import { LoginResponse, LoginWithPasswordBody } from "./types";

export const loginWithPassword = async (body: LoginWithPasswordBody): Promise<LoginResponse | null> => {

  return await api.post<ApiResponse<LoginResponse>>("/auth/login-with-password/", body)
  .then(res => res.data.data)
  .catch(() => {return null});
};
